import { render, staticRenderFns } from "./CategoriasView.vue?vue&type=template&id=07dc4f73&scoped=true"
import script from "./CategoriasView.vue?vue&type=script&lang=js"
export * from "./CategoriasView.vue?vue&type=script&lang=js"
import style0 from "./CategoriasView.vue?vue&type=style&index=0&id=07dc4f73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dc4f73",
  null
  
)

export default component.exports